/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'disable': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M182.095 120.613c-216.242 182.116-243.83 505.114-61.502 721.292s505.135 243.851 721.44 61.502 243.83-505.22 61.566-721.44-505.326-243.64-721.504-61.354zm35.268 639.797a385.431 385.431 0 012.306-499.296l490.156 581.574C550.537 938.23 340.94 906.94 217.363 760.325zm586.99 2.687L314.197 181.31c159.288-95.543 368.886-64.252 492.462 82.384a385.368 385.368 0 01-2.306 499.317z"/>'
  }
})
